import { environment } from 'src/environments/environment';

export class LoginRequest {
  client_id: string;
  client_secret: string;
  grant_type: string;
  token: string;

  constructor(model?: any) {
    this.client_id = environment.clientId;
    this.client_secret = environment.clientSecret;
    this.grant_type = 'https://openfiber.it/grants/token';
    this.token = model.token;
  }
}
